/*
 * Copyright 2023, Corning Optical Communications
 * All Rights Reserved.
 */

import { AppState } from "../";

export const searchKeywordSelector = ((state: AppState) => state.search.searchedKeyword);
export const searchPageSelector = ((state:AppState) => state.search.page);
export const searchKeywordByScopeSelector = (scope: string) => (state: AppState) => state.search.scopedKeywords?.[scope] || "";